export enum TRAINING_NAMES {
  'ESC_FOR_NEXT' = 'ESC_FOR_NEXT',
}
